import {getMethod, putMethod} from '~/api'

async function get(contractId) {
    return await getMethod(`/api/ownVisaCustomFields/${contractId}`)
}

async function put(contractId, request) {
    return await putMethod(`/api/ownVisaCustomFields/${contractId}`, request)
}

export {get, put}
